import React from 'react';

export const EnvironmentBanner: React.FC = () => {
  const getEnvironment = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('stockwise-dev.')) return 'development';
    if (hostname.includes('stockwise-staging.')) return 'staging';
    return 'production';
  };

  const environment = getEnvironment();

  if (environment === 'production') {
    return null; // Don't show banner in production
  }

  const bannerStyles = {
    development: 'bg-blue-600 text-white',
    staging: 'bg-yellow-600 text-white',
  };

  return (
    <div className={`${bannerStyles[environment as keyof typeof bannerStyles]} text-center py-1 text-sm font-medium`}>
      {environment.toUpperCase()} ENVIRONMENT - {window.location.hostname}
    </div>
  );
};